// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__aBeRA","head":"ProcedureTableInfo_head__3GUQQ"};